/* eslint-disable */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@/assets/style/base.scss"
import { formatPriceUSD } from "@/store/utils/util.utils"
import Zendesk from "@dansmaculotte/vue-zendesk"
import _ from "lodash"
import moment from "moment"
import VScrollLock from "v-scroll-lock"
import { VTooltip, VPopover } from "v-tooltip"
import Vue from "vue"
import VueFacebookPixel from "vue-analytics-fb"
import checkView from "vue-check-view"
import VueDragDrop from "vue-drag-drop"
import VueEllipseProgress from "vue-ellipse-progress"
import GAuth from "vue-google-oauth2"
import VueMoment from "vue-moment"
import VueMq from "vue-mq"
import VueNativeNotification from "vue-native-notification"
import VueObserveVisibility from "vue-observe-visibility"
import { VueReCaptcha } from "vue-recaptcha-v3"
import VueSanitize from "vue-sanitize"
import VueScrollTo from "vue-scrollto"
import vSelect from "vue-select"
import VueSocialSharing from "vue-social-sharing"
import Vue2Filters from "vue2-filters"
import VueSmoothScroll from "vue2-smooth-scroll"
import Vue2TouchEvents from "vue2-touch-events"
import Vuelidate from "vuelidate"
import App from "./App"
import router from "./router"
import store from "./store/index.store"
import { MIXINS } from '@/utils/mixins';

/**
 * 3rd Party Services
 */

// SSO - Google
const gauthOption = {
  clientId: process.env.GOOGLE_CLIENT_ID,
  scope: "profile email",
  prompt: "select_account",
}
Vue.use(GAuth, gauthOption)

// SSO - Apple
AppleID.auth.init({
  clientId: process.env.APPLE_CLIENT_ID,
  scope: "name email",
  redirectURI: process.env.APPLE_REDIRECT_URI,
  state: "PROGUIDES",
  nonce: "PROGUIDES",
  usePopup: true,
})

// Customer Support
Vue.use(Zendesk, {
  key: process.env.ZENDESK_KEY,
  hideOnLoad: true,
  settings: {
    webWidget: {
      chat: {
        concierge: {
          avatarPath: process.env.PROGUIDES_WEB_URL + "/public/media/logos/aimlabs/v1/logo_circle_black.png",
          name: "ProGuides VIP Team",
          title: { "*": "Available to chat now" },
        },
        departments: {
          select: process.env.ZENDESK_DEPARTMENT_ID_PROGUIDES,
        },
        title: { "*": "Customer Service" },
      },
      contactForm: {
        ticketForms: [
          {
            id: process.env.ZENDESK_TICKET_FORM_ID_GENERAL_ISSUE,
            title: false,
          },
        ],
      },
    },
  },
})

// Facebook Pixel
Vue.use(VueFacebookPixel)
store.dispatch("Tracking/initFbq")

// Rudderstack
;(function(document) {
  const rudderstackScript = document.createElement("script");
  rudderstackScript.innerHTML = `!function(){var e=window.rudderanalytics=window.rudderanalytics||[];e.methods=["load","page","track","identify","alias","group","ready","reset","getAnonymousId","setAnonymousId","getUserId","getUserTraits","getGroupId","getGroupTraits","startSession","endSession"],e.factory=function(t){return function(){e.push([t].concat(Array.prototype.slice.call(arguments)))}};for(var t=0;t<e.methods.length;t++){var r=e.methods[t];e[r]=e.factory(r)}e.loadJS=function(e,t){var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.rudderlabs.com/v1.1/rudder-analytics.min.js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a)},e.loadJS(),
  e.load("${process.env.RUDDERSTACK_ANALYTICS_WRITE_KEY}", "${process.env.RUDDERSTACK_ANALYTICS_DATA_PLANE_URL}")}();`
  document.head.appendChild(rudderstackScript);
})(document)

Vue.mixin(MIXINS);

// Reddit Pixel
!(function (w, d) {
  if (!w.rdt) {
    var p = (w.rdt = function () {
      p.sendEvent
        ? p.sendEvent.apply(p, arguments)
        : p.callQueue.push(arguments)
    })
    p.callQueue = []
    var t = d.createElement("script")
    ;(t.src = "https://www.redditstatic.com/ads/pixel.js"), (t.async = !0)
    var s = d.getElementsByTagName("script")[0]
    s.parentNode.insertBefore(t, s)
  }
})(window, document)
store.dispatch("Tracking/initRedditPixel")

// UserLeap
;(function (l, e, a, p) {
  window.UserLeap = function () {
    U._queue.push(arguments)
  }
  let U = window.UserLeap
  U.appId = a
  U._queue = []
  a = l.createElement("script")
  a.async = 1
  a.src = e + "?id=" + U.appId
  p = l.getElementsByTagName("script")[0]
  p.parentNode.insertBefore(a, p)
})(
  document,
  "https://cdn.userleap.com/shim.js",
  process.env.USERLEAP_ENVIRONMENT_ID
)

// Klaviyo
if (!window._learnq) {
  let klaviyo = document.createElement("script")
  klaviyo.setAttribute(
    "src",
    `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${process.env.KLAVIYO_PUBLIC_API_KEY}`
  )
  document.head.appendChild(klaviyo)
}

// Optimizely
const optimizelySDK = require("@optimizely/optimizely-sdk")
optimizelySDK.setLogLevel(
  process.env.NODE_ENV === "production" ? "error" : "info"
)
const optimizelyClientInstance = optimizelySDK.createInstance({
  sdkKey: process.env.OPTIMIZELY_SDK_KEY,
})
Object.defineProperty(Vue.prototype, "$optimizely", {
  value: optimizelyClientInstance,
})

Vue.config.productionTip = false

/**
 * Utility libraries
 */
Vue.use(VScrollLock, {
  bodyScrollOptions: {
    reserveScrollBarGap: true,
  },
})
Vue.use(Vue2TouchEvents)
Vue.use(VueEllipseProgress)
Vue.use(VueMoment, { moment })
Vue.use(VueMq, {
  breakpoints: {
    xs: 480,
    sm: 768,
    md: 992,
    lg: 1200, // 992 < mq < 1200
    xl: 1440,
    xxl: Infinity,
  },
  defaultBreakpoint: "sm",
})
Vue.use(VueNativeNotification, {
  requestOnNotify: true,
})
Vue.use(VueObserveVisibility)
Vue.use(VueReCaptcha, { siteKey: "6LfAmpEUAAAAAKy5z_GKn2Ktw5R6efGLFFNqW4Y6" })
Vue.use(VueSanitize)
Vue.use(VueSmoothScroll)
Vue.use(VueScrollTo)
Vue.use(Vuelidate)
Vue.use(checkView)

// Lodash
Object.defineProperty(Vue.prototype, "$_", { value: _ })

/**
 * Pre-built components
 */

// Tooltip Library - https://github.com/Akryum/v-tooltip
Vue.directive("tooltip", VTooltip)
Vue.component("v-popover", VPopover)
Vue.component("v-select", vSelect)
Vue.use(VueSocialSharing)
Vue.use(VueDragDrop)

/**
 * Filters
 */
Vue.use(Vue2Filters)
Vue.filter("ordinalIndicator", function (value) {
  if (!value || !parseInt(value)) {
    return ""
  }
  const i = parseInt(value)
  var j = i % 10,
    k = i % 100
  if (j == 1 && k != 11) {
    return `${i}st`
  }
  if (j == 2 && k != 12) {
    return `${i}nd`
  }
  if (j == 3 && k != 13) {
    return `${i}rd`
  }
  return `${i}th`
})
Vue.filter("formatCoachRating", function (value) {
  return parseFloat((parseInt(value) / 20).toFixed(1))
})
Vue.filter("formatPriceUsd", function (value) {
  return formatPriceUSD(value)
})

new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>",
})



// WEBPACK FOOTER //
// ./src/main.js